import React from 'react'

type planCardProps = {
  title: string
  caption?: string
  price: string
  description: string[]
  buttonText: React.ReactChild
  cardColor?: string
  cents: string
  months?: string
  premium?: boolean
  benefits?: string[]
  value?: string
}

export default function PlanCard(props: planCardProps) {
  const {
    title,
    price,
    caption,
    description,
    buttonText,
    cardColor,
    cents,
    months,
    premium,
    benefits,
    value,
  } = props
  return (
    <div className="w-full p-4  md:w-1/2 lg:w-80 ">
      <label
        className={`
        flex flex-col 
        relative
        rounded-lg 
        shadow-lg 
        group card-group 
        ${
          premium
            ? 'border-2 border-sky-500 bg-sky-400 shadow-2xl text-white'
            : 'border-2 border-sky-300'
        }
        hover:bg-blue-secondary 
        cursor-pointer 
        hover:shadow-2xl
        `}
      >
        <div className="w-full px-4 py-6 rounded-t-lg card-section-1">
          <h3
            className="mx-auto text-base font-semibold text-center underline"
            style={{ color: premium ? '' : cardColor }}
          >
            {title}
          </h3>
          <p
            className="text-4xl font-bold text-center "
            style={{ color: premium ? '' : cardColor }}
          >
            R$ {Math.trunc(Number(price))},
            <span className="text-3xl">{cents.split('.')[1]}</span>
            <span className="text-xs">{months}</span>
          </p>
          <p
            className="text-xs text-center uppercase"
            style={{ color: premium ? '' : cardColor }}
          >
            {caption}
          </p>
        </div>
        <div
          className="flex flex-col items-center justify-center w-full h-full py-6 rounded-b-lg"
          style={{ backgroundColor: cardColor }}
        >
          <br />
          <div className="flex flex-col h-full w-full ">
            <div className="flex flex-col justify-center">
              {description.map((item) => (
                <div key={item} className="flex justify-center">
                  <p className="text-white text-left text-white">{item}</p>
                </div>
              ))}
            </div>

            {benefits && (
              <div className="flex flex-col justify-center">
                <br />
                {benefits.map((item) => (
                  <p
                    key={item}
                    className="flex justify-center font-semibold text-white text-left"
                  >
                    <span className="material-icons align-middle">done</span>
                    <span className="pl-2">{item}</span>
                  </p>
                ))}
              </div>
            )}

            <div className="flex flex-col justify-center">
              <br />
              <div className="flex justify-center">
                <p className="text-xl text-white">{value}</p>
              </div>
            </div>
          </div>

          <br />
          {buttonText}
        </div>
      </label>
    </div>
  )
}
